module.exports = __webpack_public_path__ + "img/1.1202e0a6.png";